module.exports = __webpack_public_path__ + "img/logo.c8dc1bc5.svg";